module.exports = __webpack_public_path__ + "02_mid_brown.bcfb16a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/02_mid_brown.png
// module id = yk3h
// module chunks = 0